module.exports = __webpack_public_path__ + "img/slack-notification.19981307.svg";